import { InjectionToken } from '@angular/core';
import {
  LegalTermPreviewLayout
} from '@sbd-doug-frontend/shared/lib/shared-components/legal-term-previewer/legal-term-previewer.component';

export interface LegalTermPreviewAdapter<T = unknown> {
  getTitle(term: T): string;
  getSubtitle?(term: T): string | null;
  getHtml(term: T): string | null;
  getStatusLabel?(term: T): string | null;
  getVersion?(term: T): string | null;
  getEffectiveAt?(term: T): string | null;
  getExpiresAt?(term: T): string | null;
  getLayout?(term: T): LegalTermPreviewLayout | null;
  getCheckboxLabel?(term: T): string | null;
  getCtaLabel?(term: T): string | null;
  getLockSystem?(term: T): boolean | null;
  getDeadline?(term: T): string | null;
  getDeadlineExceeded?(term: T): boolean | null;
  getRemoveReminderButton?(term: T): boolean | null;
}

export const LEGAL_TERM_PREVIEW_ADAPTER = new InjectionToken<LegalTermPreviewAdapter<any>>(
  'LEGAL_TERM_PREVIEW_ADAPTER'
);
